import { gql } from '@apollo/client';

export const GET_DISTRICT = gql`
  query getDistrict($districtId: Int!) {
    getDistrict(districtId: $districtId) {
      districtId
      name
      branding {
        logoAlt
        logoLinkUrl
        logoUrl
      }
      communitySettings {
        flyerDisclaimer
        aidaStatus
        aidaExpirationDate
      }
    }
  }
`;
